import { z } from 'zod'

/** Represents the enum public.org_plan_tier */
enum OrgPlanTier {
  STANDARD = 'STANDARD',
  PREMIUM = 'PREMIUM',
  ENTERPRISE = 'ENTERPRISE',
}

export default OrgPlanTier

/** Zod schema for org_plan_tier */
export const orgPlanTier = z.enum(['STANDARD', 'PREMIUM', 'ENTERPRISE'])
